import { useState } from 'react';
import CaipirinhaRequest from '../../requests/caipirinha-api/caipirinha.request';
import { addSessionIdToTMX, getTMXSessionId } from '../../utils/threatmetrix';
import AlertConstants from '../../constants/alert.constant';
import { useAlert } from '../../containers/Alert';
import { currentBrowserIs } from '../../utils/browserInfo.util';

export const useAnalyzeSession = () => {
  const { alert } = useAlert();
  const [isLoading, setIsLoading] = useState(true);

  const alternativeFlow = async (id: string, document: string) => {
    const sessionId = getTMXSessionId();

    if (sessionId === '') {
      try {
        const response = await CaipirinhaRequest.getSessionId(id, document);

        if (response?.id)
          addSessionIdToTMX(response?.id);

        setIsLoading(false);
      } catch (error) {
        alert(AlertConstants.error);
      }
    } else {
      setIsLoading(false);
    }
  };

  const analyze = async (id: string, document: string) => {
    if (currentBrowserIs('safari')) {
      await alternativeFlow(id, document);
    } else {
      setIsLoading(false);
    }
  };

  return { isLoading, analyze };
};
